<template>
  <v-container>
    <avs-backButton
      v-if="!inDialog"
      backTo="PartnerCards"
    />
    <AvsSteppers
      :value="tab"
      @change="v => (tab = v)"
    >
      <template v-slot:headers>
        <AvsStep step="1">
          {{ $t("General") }}
          <small v-show="!isFormValid.generale">{{ $t("commons.validation_issues") }}</small>
        </AvsStep>
      </template>
      <template v-slot:items>
        <v-stepper-content step="1">
          <v-form
            ref="form-generale"
            v-model="isFormValid.generale"
            class="pt-2"
            lazy-validation
          >
            <v-text-field
              clearable
              type="text"
              v-model="partnerCard.name"
              :label="$t('Name.')"
              dense
              outlined
              :rules="rules.name"
            />


            <v-textarea
              v-model="partnerCard.description"
              :rules="rules.description"
              clearable
              dense
              outlined
              :label="$t('Description')"
              rows="5"
            />

            <v-row class="mt-0 d-flex align-baseline mb-4">
              <ImageInputOther
                v-model="partnerCard.logo"
                dense
                :labelText="$t('Logo')"
              />
              <ImageInputOther
                v-model="partnerCard.template"
                dense
                :labelText="$t('Template')"
              />
              <ImageInputOther
                v-model="partnerCard.captionImage"
                dense
                :labelText="$t('Image Context')"
              />
            </v-row>
          </v-form>
        </v-stepper-content>
      </template>
      <v-spacer></v-spacer>
      <template v-slot:actions>
        <avs-stepButton
          class="mx-2"
          icon="mdi-chevron-left"
          @click="tab--"
          :disabled="tab <= 1"
          :name="$t('commons.previous')"
        />
        <avs-stepButton
          class="mx-2"
          icon="mdi-chevron-right"
          right
          @click="save"
          :name="$t('save')"
        />
      </template>
    </AvsSteppers>
  </v-container>
</template>

<script>
import _ from "lodash"

import { PartnerCardService } from "@/services"
import { mkPartnerCard } from "@/utils/datamodels"

import { ImageInputOther } from "@/components"
import { required } from "@/utils/validator"

export default {
  name: "PartnerCardCreateUpdate",
  components: {
    AvsStep: () => import("@/components/generics/general/AvsStep.vue"),
    AvsSteppers: () => import("@/components/generics/general/AvsSteppers.vue"),
    ImageInputOther
  },
  props: {
    inDialog: {
      type: Boolean,
      default: false
    },
    inDialogParams: {
      type: Object,
      default: () => {}
    }
  },
  data: function () {
    return {
      partnerCardRef: null,
      partnerCard: mkPartnerCard(),
      deleteDialogIsOpen: false,
      tab: this.$route.params.tab ? this.$route.params.tab : 1,
      nextLabel: this.$t("commons.save"), //NEXT.DEFAULT,
      loading: false,
      step: -1,
      disabled: false,
      rules: {
        name: [required],
        pia: [],
        applicable_document: [],
        doc_rev: [],
        performer: [],
        quality_control: [],
        technical_control: [],
      },
      isFormValid: {
        generale: false,
      },
      validateRequest: {
        pictures: 0
      },
      areasData: {}
    }
  },
  created() {
    this.fetchPartnerCard()
  },
  methods: {
    save() {
      this.$refs["form-generale"].validate()
      this.$nextTick(() => {
        if (this.partnerCardExists) {
            this.updatePartnerCard()
          } else {
            this.createPartnerCard()
          }
      })
    },
    tabIncrement() {
      return this.$router.push({ name: "PartnerCardsView" })
    },
    send(msg, color) {
      this.$store.commit("app/message", { msg, color })
    },
    getPartnerCard(id) {
      if (id) {
        let t = this
        PartnerCardService.get(this, id).then(r => {
          t.partnerCard = r
          t.partnerCardRef = _.cloneDeep(t.partnerCard)
        })
      }
    },
    createPartnerCard() {
      let tmp = _.cloneDeep(this.partnerCard)

      // We rename "file_url" to "file" for the create to work
      this.loading = true
      PartnerCardService.create(this, tmp)
        .then(response => {
          this.partnerCard = response
          this.partnerCardRef = _.cloneDeep(response)
          this.send(
            this.$t("messages.success.saved", {
              entity: this.$tc("categories.pcqdsi.name", 1)
            }),
            "success"
          )
          this.$router.push({ name: "PartnerCards" })
        })
        .catch(err => {
          if (err.response && err.response.status === 403) {
            // alert("Access denied: You do not have permission to access this resource.")
            this.$store.commit("app/message", {
              msg: this.$t("messages.error.permission_denied"),
              color: "error"
            })
          } else {
            let message = ""
            for (const e in err.response.data) {
              message += "- " + e + " : " + err.response.data[e] + "  "
            }
            this.send(message, "error")
          }
        })
        .finally(() => {
          this.loading = false
        })
    },
    updatePartnerCard() {
      const requests = []
      const partnerCardAttrs = [
        "name",
        "description",
        "logo",
        "template",
        "captionImage",
      ]
      if (!_.isEqual(_.pick(this.partnerCard, partnerCardAttrs), _.pick(this.partnerCardRef, partnerCardAttrs))) {
        requests.push(PartnerCardService.update(this, this.partnerCard.id, this.partnerCard))
      }
      if (requests.length > 0) {
        this.loading = true
        // Promise.all(requests)
        PartnerCardService.update(this, this.partnerCard.id, this.partnerCard)
          .then(() => {
            this.send(
              this.$t("messages.success.updated", {
                entity: this.$tc("categories.pcqdsi.name", 1)
              }),
              "success"
            )
            this.$router.push({ name: "PartnerCards" })
          })
          .catch(err => {
            if (err.response && err.response.status === 403) {
              // alert("Access denied: You do not have permission to access this resource.")
              this.$store.commit("app/message", {
                msg: this.$t("messages.error.permission_denied"),
                color: "error"
              })
            } else {
              let message = ""
              for (const e in err.response.data) {
                message += "- " + e + " : " + err.response.data[e] + "  "
              }
              this.send(message, "error")
            }
          })
          .finally(() => {
            this.loading = false
          })
      } else {
        this.send(this.$t("messages.success.no_updated"), "info")
      }
    },
    fetchPartnerCard() {
      // Load nonconformity
      this.getPartnerCard(this.id)
    },
    handleInput() {
      this.$emit("input", this.partnerCard)
    },
  },
  watch: {
    tab(newValue, oldValue) {
      this.save()
      this.nextLabel = this.$t("commons.finish")
    }
  },
  computed: {

    id() {
      return this.inDialog ? this.inDialogParams?.id : this.$route.params.id || null
    },
    partnerCardExists() {
      return this.partnerCard.id > 0
    }
  }
}
</script>

<style lang="scss" scoped>
.custom-container {
  display: flex;
  flex-direction: column;
  height: 80vh;
}
.stepper-item {
  flex: 1 1 auto;
  overflow-y: auto;
}
</style>
